import { type FC, memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from '../../../types/jackpot.types';
import { useSeasonalBrandingJackpotPanel } from 'store/featureFlags/featureFlagsStore';

import styles from './BellLink.module.css';

const BellLinkJackpot: FC<StandardJackpotProps> = (props) => {
  const seasonalBranding = useSeasonalBrandingJackpotPanel();

  const bellLinkIcons = {
    panel: seasonalBranding ? `/brandings/${seasonalBranding}/group_bell_link/panel` : '/group_bell_link/panel',
    grand: '/group_bell_link/grand',
    major: '/group_bell_link/major',
    minor: '/group_bell_link/minor',
    mini: '/group_bell_link/mini',
  };

  return (
    <StandardJackpot
      {...props}
      icons={bellLinkIcons}
      className={styles['bellLinkTheme']}
    />
  );
};

export default memo(BellLinkJackpot);
